<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
  <g fill-rule="nonzero" fill="none">
    <path fill="#FF5F00" d="M16.9 14.74h-7V1.77h7z"/>
    <path d="M10.35 8.25c0-2.63 1.2-4.98 3.06-6.49A7.82 7.82 0 008.46 0c-4.42 0-8 3.7-8 8.25a8.13 8.13 0 008 8.25c1.87 0 3.59-.66 4.95-1.76a8.33 8.33 0 01-3.06-6.49z" fill="#EB001B"/>
    <path d="M26.35 8.25a8.13 8.13 0 01-8 8.25 7.83 7.83 0 01-4.95-1.76 8.33 8.33 0 003.06-6.49c0-2.63-1.2-4.98-3.06-6.49A7.83 7.83 0 0118.35 0c4.42 0 8 3.7 8 8.25z" fill="#F79E1B"/>
  </g>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcyMastercard2',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 27 17',
    },
  },
};
</script>

<style scoped>
  
</style>